import Vue from 'vue';
import VueI18n from 'vue-i18n';
import views from '@/i18n/pt-BR/Views';
import models from '@/i18n/pt-BR/Models';
import messages from '@/i18n/pt-BR/Messages';
import global from '@/i18n/pt-BR/Global';
import attributes from '@/i18n/pt-BR/Attributes';
import dialog from '@/i18n/pt-BR/Dialog';

// Encapsula todas as mensagens de internacionalização
const translate = {
  'pt-BR': {
    views,
    messages,
    models,
    global,
    attributes,
    dialog,
  },
};

Vue.use(VueI18n);

const i18n = new VueI18n({
  locale: 'pt-BR', // set locale
  messages: translate, // set locale messages
});

// Fix para poder utilizar internacionalização nos componentes que são criados dinamicamente,
// como por exemplo os Dialogs
Vue.prototype.$t = (key, ...args) => i18n.t(key, args);

export default i18n;



// WEBPACK FOOTER //
// ./src/i18n/index.js